export const blockIconsHardwareKeyboardNew = (
	<span className='material-symbols-outlined'>keyboard</span>
);
